/**
 * Endpoint for triggering a password reset email to be sent
 */

import axios from "axios";

import type { SendResetEmailRequestProto_Body } from "@noom/noom-contracts/noom_contracts/backend/passwordreset/password_reset_service";
import { Api } from "@noom/noomscape";

import { captureException } from "@/utils/sentry";

// This is passed as an environment variable at build time,
// or when running locally from the .env file at the root of the project
const ANONYMOUS_CLIENT_TOKEN = process.env.HIVE_ANONYMOUS_CLIENT_TOKEN;

Api.register(
  "account.passwordResets",
  ({
    email,
    postResetRedirectUrl,
  }: {
    email: string;
    postResetRedirectUrl: string;
  }) => {
    if (!ANONYMOUS_CLIENT_TOKEN) {
      const error = new Error("ANONYMOUS_CLIENT_TOKEN is not set");
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error(error);
      } else {
        captureException(error);
      }
      return Promise.reject(error);
    }

    const body: SendResetEmailRequestProto_Body = {
      email,
      postResetRedirectUrl,
      product: "COACH",
    };

    return axios({
      url: "/users/v2/passwordResets/sendResetEmail",
      urlWithPathParams: "/users/v2/passwordResets/sendResetEmail",
      baseURL: window.ENV.SERVER_URL,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ANONYMOUS_CLIENT_TOKEN}`,
      },
      data: body,
    });
  },
);
